export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14510.d45e080b.jpg";